<template>
  <div id="transaction-tab">
    <transaction-list
      v-if="!!contract.id"
      :contract-id="contract.id"
      :disbursed-on="contract.submittedOn"
      read-only
      :undo="(contract.status === CONTRACT_STATUSES.DISBURSED) || (contract.status === CONTRACT_STATUSES.OVERDUE) && canUndoContract"
      v-on:remove-transaction="updateContract"
      ref="transactionListRef"
    />
  </div>
</template>

<script>
import { ref, watch, computed } from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import { hasPermissions } from '@/helpers/permission';

import TransactionList from '@/components/TransactionList';
import { CONTRACT_STATUSES, PERMISSIONS } from '@/consts';

const { useState } = createNamespacedHelpers('contractDetail');
const { useActions: useContractActions } = createNamespacedHelpers('contractDetail');

export default {
  name: 'TransactionTab',
  components: {
    TransactionList
  },
  setup() {
    const { targetingContract: contract } = useState(['targetingContract']);
    const { getContractDetail } = useContractActions(['getContractDetail']);

    const transactionListRef = ref(null);

    const updateContract = () => {
      getContractDetail(contract.value.publicId);
    };

    const canUndoContract = computed(() => hasPermissions([PERMISSIONS.UNDO_CONTRACT]));

    watch(contract, () => {
      transactionListRef.value.fetchTransactions();
    });

    return {
      contract,
      transactionListRef,
      updateContract,
      CONTRACT_STATUSES,
      canUndoContract
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/colors";

#transaction-tab {
  /deep/ table {
    width: 100%;
    border-collapse: inherit;
    border-spacing: 0;
    background-color: $ghostWhite;

    thead {
      text-transform: uppercase;
      font-weight: bold;
      text-align: center;
      th {
        background-color: $brightMaroon;
        color: $white;
        padding: 15px 10px;
        border-top: 1px solid $alto;
        border-bottom: 1px solid $alto;
        font-size: 14px;

        &:first-child {
          border-top-left-radius: 3px;
          border-bottom-left-radius: 3px;
          border-left: 1px solid $alto;

        }

        &:last-child {
          border-top-right-radius: 3px;
          border-bottom-right-radius: 3px;
          border-right: 1px solid $alto;
        }
      }
    }

    tbody {
      text-align: center;

      tr {
        background-color: $babyPowder;
        transition: all .2s ease-in-out;

        &:hover {
          background-color: $ghostWhite;
        }

        td {
          padding: 15px 5px;
          border-top: 1px solid $alto;
          border-bottom: 1px solid $alto;
          background-color: $babyPowder;

          &:first-child {
            border-top-left-radius: 3px;
            border-bottom-left-radius: 3px;
            border-left: 1px solid $alto;
          }

          &:last-child {
            border-top-right-radius: 3px;
            border-bottom-right-radius: 3px;
            border-right: 1px solid $alto;
            padding-right: 20px;
          }

          .icon {
            margin-right: 10px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
